export default __webpack_public_path__ + "static/media/02.f9beca7c.jpg";